import React from 'react';
import RegisterUser from './registeruser.js';
import RegisterOrg from './registerorg.js';

export default class Register extends React.Component
{
    constructor(props)
    {
        super(props);
        this.state = {
            regmode: "Individual"
        };
    }
    regModeButtonClick(e, mode)
    {
        e.preventDefault();
        this.setRegMode(mode);
    }
    setRegMode(mode)
    {
        this.setState({regmode: mode});
    }

    render()
    {
        return (
            <div>
                <h2>Registration</h2>
                <a href="/" className={this.state.regmode === "Individual" ? "lmsbutton lmsbuttonactive" : "lmsbutton"} 
                    onClick={(e) => this.regModeButtonClick(e, "Individual")}>
                      Register an Individual
                </a>
                <a href="/" className={this.state.regmode === "Organization" ? "lmsbutton lmsbuttonactive" : "lmsbutton"} 
                    onClick={(e) => this.regModeButtonClick(e, "Organization")}>
                      Register an Organization
                </a>
                {this.state.regmode === "Individual" ? (
                    <RegisterUser api={this.props.api} controller="Registration" action="RegisterUser" buttonText="Register" />
                ) : this.state.regmode === "Organization" ? (
                    <RegisterOrg api={this.props.api} />
                ) : null}
                
            </div>
        )
    }

}


// WEBPACK FOOTER //
// ./src/registration/register.js